import { GETTERS, STATE } from "./names";
import type { State } from "./types";

export default {
}